import Vue from 'vue'
import auth from '@websanova/vue-auth/src/index';
import bearer from './../helpers/bearer';
import authAxios from '@websanova/vue-auth/drivers/http/axios.1.x';
import vueRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x';
import router from '@/router/'
import utils from "./../helpers/utils";

Vue.router = router;

const options = {
  auth: bearer,
  http: authAxios,
  router: vueRouter,
  tokenDefaultKey: process.env.VUE_APP_AUTH_TOKEN_KEY,
  rememberKey: process.env.VUE_APP_AUTH_REMEMBER_KEY,
  tokenImpersonateKey: process.env.VUE_APP_AUTH_IMPERSONATE_KEY,
  stores: ['storage'],
  staySignedInKey: process.env.VUE_APP_AUTH_STAY_SIGNED_KEY,
  rolesKey: 'role',
  fetchData: { url: '/users/logged', method: 'GET', enabled: true },
  loginData: { url: '/security/login', method: 'POST', redirect: '/', fetchUser: true, staySignedIn: true },
  logoutData: {
    url: '/security/logout',
    method: 'POST',
    redirect: '/security/login',
    makeRequest: true,
    transformRequest: function (data) {
      const token = Vue.auth.token()
      if (utils.isJSON(token)) {
        return JSON.stringify({ refresh: JSON.parse(token).refresh })
      } else {
        return data
      }
    }
  },
  refreshData: {
    url: '/security/refresh',
    method: 'POST',
    enabled: true,
    interval: 2,
    transformRequest: function (data) {
      const token = Vue.auth.token()
      if (utils.isJSON(token)) {
        return JSON.stringify({ refresh_token: JSON.parse(token).refresh_token })
      } else {
        return data
      }
    }
  },
  unimpersonateData: {
    url: '/security/unimpersonate',
    method: 'GET',
    fetchUser: true,
    makeRequest: true,
    redirect: '/'
  },
  impersonateData: (data) => {
    console.log('data', data)
  },
  parseUserData: (data) => data || {}
}

Vue.use(auth, options);
